import { useAuth } from "../../hooks/useAuth";
import { useOrgSnapshot } from "../../hooks/useOrgSnapshot";
import { PageHeader } from "../../components/AppLayout";
import { Card } from "../../components/shared/Card";
import { StatusBadge } from "../../components/shared/StatusBadge";
import { Spinner } from "../../components/shared/Spinner";

const ROLE_LABEL: Record<string, string> = {
  owner: "Owner",
  admin: "Admin",
  member: "Member",
  external: "External",
};

export function MemberOverview() {
  const { profile } = useAuth();
  const { org, role, loading } = useOrgSnapshot();

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <Spinner />
      </div>
    );
  }

  const displayName =
    (profile as { display_name?: string } | null)?.display_name?.trim() ?? "";
  const greeting = displayName ? `Hola, ${displayName}` : "Hola";
  const roleLabel = role ? ROLE_LABEL[role] ?? role : "Sin rol";

  return (
    <>
      <PageHeader
        title={greeting}
        subtitle={(org as { name?: string })?.name ?? undefined}
      />
      <div className="grid gap-4 sm:grid-cols-2">
        <Card className="p-5">
          <div className="text-xs font-semibold uppercase tracking-wider text-ink-3">
            Tu rol
          </div>
          <div className="mt-2 flex items-baseline gap-2">
            <div className="text-2xl font-black text-ink">{roleLabel}</div>
            <StatusBadge status={role ? "active" : "invited"} />
          </div>
          <p className="text-xs text-ink-3 mt-2">
            {role === "external"
              ? "Solo ves los workspaces que se te asignen explícitamente."
              : "Compartes el pool de créditos y el storage con el resto de la organización."}
          </p>
        </Card>
      </div>
    </>
  );
}
